import { buildFunnelPath } from './url';

export function redirectToOrderSummary(orderId, authKey, funnelId) {
  const orderSummaryUrl = `/orders/${orderId}/authenticate?key=${authKey}`;
  window.location.assign(funnelId ? buildFunnelPath(orderSummaryUrl, funnelId) : orderSummaryUrl);
}

export async function sendOrderComplete(orderId, apiBaseUrl) {
  return fetch(
    `${apiBaseUrl ?? process.env.NEXT_PUBLIC_CHECKOUT_API}/complete?orderId=${orderId}`,
    {
      // Needed for CORS request to send cookies
      credentials: 'include',
      method: 'PUT',
    }
  );
}

async function pollOrder(orderId, apiBaseUrl) {
  const req = await fetch(
    `${apiBaseUrl ?? process.env.NEXT_PUBLIC_CHECKOUT_API}/poll-complete?orderId=${orderId}`,
    {
      // Needed for CORS request to send cookies
      credentials: 'include',
      method: 'GET',
    }
  );

  if (req.status === 200) {
    return true;
  }
}

async function pollOrderComplete(orderId, apiBaseUrl) {
  let orderComplete = false;
  let attempts = 0;

  while (!orderComplete && attempts < 10) {
    orderComplete = await pollOrder(orderId, apiBaseUrl);
    if (!orderComplete) {
      attempts++;
      await new Promise(resolve => setTimeout(resolve, 1000));
    }
  }
}

// Hits the api to complete the order and redirects to the order summary page.
export async function finishOrder(orderId, authKey, apiBaseUrl, funnelId) {
  // Sends the complete task to the queue
  await sendOrderComplete(orderId, apiBaseUrl);

  // Client polls the api to check if the order is complete so we can redirect
  await pollOrderComplete(orderId, apiBaseUrl);

  redirectToOrderSummary(orderId, authKey, funnelId);
}
